import { getUrlParamRaw, decodeUrlQueryValue } from 'components/Dashboard/utilities/getUrlParam';
import { parseSearchQuery } from 'utils/stringFunctions';

const returnParamValue = (property) => {
  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  const propertyValue = urlParams.get(property);
  const wrappedInQuotes = parseSearchQuery(propertyValue)?.length === 1;
  return propertyValue
    ? wrappedInQuotes
      ? [decodeUrlQueryValue(getUrlParamRaw(property))]
      : parseSearchQuery(decodeUrlQueryValue(getUrlParamRaw(property)))
    : [];
};

export default returnParamValue;
